import {documentToReactComponents} from '@contentful/rich-text-react-renderer'
import {BLOCKS} from '@contentful/rich-text-types'
import {SectionIntro} from '@primer/react-brand'
import type {PrimerComponentSectionIntro} from '../../../lib/types/contentful'

export type ContentfulSectionIntroProps = {
  component: PrimerComponentSectionIntro
}

export function ContentfulSectionIntro({component}: ContentfulSectionIntroProps) {
  return (
    <SectionIntro align={component.fields.align}>
      <SectionIntro.Heading>{component.fields.heading}</SectionIntro.Heading>

      {component.fields.description !== undefined
        ? documentToReactComponents(component.fields.description, {
            renderNode: {
              [BLOCKS.PARAGRAPH]: (_, children: React.ReactNode) => (
                <SectionIntro.Description>{children}</SectionIntro.Description>
              ),
            },
          })
        : null}

      {component.fields.link !== undefined && (
        <SectionIntro.Link href={component.fields.link.fields.href}>
          {component.fields.link.fields.text}
        </SectionIntro.Link>
      )}
    </SectionIntro>
  )
}

try{ ContentfulSectionIntro.displayName ||= 'ContentfulSectionIntro' } catch {}